/**
 * BasicInfoTab — user details display with field grid and groups list.
 */

const BasicInfoTab = ({ basicData, userGroups, editRights, higherRole, onEdit }) => {
    if (!basicData) return null;

    return (
        <>
            {/* User Details */}
            <div className="pp-section">
                <div className="pp-section__header">
                    <h3 className="pp-section__title">User Details</h3>
                    {editRights && higherRole ? (
                        <div className="pp-section__actions">
                            <button className="dp-btn dp-btn--secondary dp-btn--sm" onClick={onEdit}>
                                ✎ Edit
                            </button>
                        </div>
                    ) : null}
                </div>
                <div className="pp-section__body">
                    <div className="upp-info-grid">
                        <div className="pp-field">
                            <span className="pp-field__label">Username</span>
                            <span className="pp-field__value pp-field__value--mono">{basicData.username || '—'}</span>
                        </div>
                        <div className="pp-field">
                            <span className="pp-field__label">Display Name</span>
                            <span className="pp-field__value">{basicData.display_name || '—'}</span>
                        </div>
                        <div className="pp-field">
                            <span className="pp-field__label">Email</span>
                            <span className="pp-field__value">{basicData.email || '—'}</span>
                        </div>
                        <div className="pp-field">
                            <span className="pp-field__label">Phone</span>
                            <span className="pp-field__value">{basicData.phone || '—'}</span>
                        </div>
                        <div className="pp-field">
                            <span className="pp-field__label">Role</span>
                            <span className="pp-field__value">
                                <span className="upp-role-badge">{basicData.user_role_name || '—'}</span>
                            </span>
                        </div>
                        <div className="pp-field">
                            <span className="pp-field__label">Title</span>
                            <span className="pp-field__value">{basicData.title || '—'}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Groups */}
            <div className="pp-section">
                <div className="pp-section__header">
                    <h3 className="pp-section__title">
                        Groups <span className="pp-section__count">({(userGroups || []).length})</span>
                    </h3>
                </div>
                <div className="pp-section__body">
                    {(userGroups || []).length === 0 ? (
                        <span style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-muted)' }}>No groups assigned</span>
                    ) : (
                        <div className="upp-groups-list">
                            {userGroups.map((g, i) => (
                                <span key={g.group_id || i} className="upp-group-tag">{g.group_name}</span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default BasicInfoTab;
